<div class="chips-tag-item"
     [style.color]="tag.fgColor"
     [style.backgroundColor]="tag.bgColor">
    <div class="clickable"
         (click)="onTagClick()">
        <aa-chips-tag-item-value [fullTagName]="tag.fullTagName"
                                 [bgColor]="tag.bgColor"
                                 [fgColor]="tag.fgColor">
        </aa-chips-tag-item-value>
    </div>
    <i class="fas fa-times"
       [style.color]="getCheckColor(tag.bgColor)"
       aria-hidden="true"
       (click)="onCancelClick(tag.tagId)">
    </i>
</div>
